import { useEffect, useMemo, useState } from "react";
import Table from "../../components/GTable/Table";
import { GetStoresData } from "../../lib/data";
import Button from "../../components/GButton/Button";
import { storesColumns, positionOfPackags, TopResultOfPackags } from "../../lib/definitions";
import { deleteStoresForm } from "../../lib/actions";
import DeleteRecord from "../../ui/Models/deleteRecord";
import Pagination from "../../ui/paginations/Paginations";
import TableSkeleton from "../../ui/sharedUi/tableSkeleton";
import { useSearchParams } from "react-router-dom";
import StoresFilter from "../../ui/searchFilter/storesFilter";
import i18n from "../../lib/i18n";
import StoreRatingsModal from "../../ui/storesUi/StoreRatingsModal";

export default function Stores() {
  const [searchParams] = useSearchParams();
  const [storesData, setStoresData] = useState([]);
  const [currentPage, setcurrentPage] = useState(1);
  const [last_page, setlast_page] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingDelete, setLoadingDelete] = useState(false);
  
  // 2. Add State for the Rating Modal
  const [ratingModal, setRatingModal] = useState({
    isOpen: false,
    storeId: null
  });

  const [deleteConfirmation, setDeleteConfirmation] = useState({
    isOpen: false,
    idToDelete: null,
  });

  const name = searchParams.get("name");
  const position = searchParams.get("position");
  const topResult = searchParams.get("topResult");
  const status = searchParams.get("status");
  const t = i18n.t.bind(i18n);

  const params = useMemo(() => {
    const tempParams = [];
    if (topResult) tempParams.push({ topResult });
    if (position) tempParams.push({ position });
    if (name) tempParams.push({ name });
    if (status) tempParams.push({ status });
    return tempParams;
  }, [status, name, topResult, position]);

  useEffect(() => {
    handleApi();
  }, [currentPage, params]);

  const handleApi = async () => {
    setIsLoading(true);
    const stores = await GetStoresData(currentPage, params);
    setStoresData([]);
    setcurrentPage(stores.pagination?.current_page || 1);
    setlast_page(stores.pagination?.last_page || 1);
    stores.data?.map((e) => setStoresData((prev) => [...prev, e]));
    setIsLoading(false);
  };

  const handlePageChange = (page) => {
    setcurrentPage(page);
  };

  // 3. Helper to open the Rating Modal
  const openRatingModal = (id) => {
    setRatingModal({ isOpen: true, storeId: id });
  };

  const closeRatingModal = () => {
    setRatingModal({ isOpen: false, storeId: null });
  };

  const openDeleteConfirmation = (id) => {
    setDeleteConfirmation({ isOpen: true, idToDelete: id });
  };

  const closeDeleteConfirmation = () => {
    setDeleteConfirmation({ isOpen: false, idToDelete: null });
  };

  const handelDelete = async () => {
    if (deleteConfirmation.idToDelete) {
      setLoadingDelete(true);
      const result = await deleteStoresForm(deleteConfirmation.idToDelete);
      if (result) {
        setLoadingDelete(false);
        handleApi();
      }
      closeDeleteConfirmation();
    }
  };

  return (
    <div className="p-8 sm:p-6 md:p-8">
      <div className="">
        <StoresFilter
          positionOfPackags={positionOfPackags}
          TopResultOfPackags={TopResultOfPackags}
          values={params}
        />
      </div>

      <div className="flex flex-col sm:flex-row sm:items-baseline border-t border-gray-500/100 bg-thirdly justify-between px-5 py-5 gap-4">
        <div></div>
        <Button
          background="#2F7A74"
          borderRadius="8px"
          color="white"
          padding="8px 20px"
          text={t("button.add_store")}
          nav={"/stores/add"}
        />
      </div>
      <div>
        {isLoading ? (
          <TableSkeleton cols={storesColumns} />
        ) : (
          <Table
            columns={storesColumns}
            rows={storesData}
            openDeleteConfirmation={openDeleteConfirmation}
            action={"stores"}
            // 4. Pass the open function to your Table
            // Ensure your Table component or storesColumns definition uses this prop!
            openOrderDetails={openRatingModal} 
            edit="/stores/edit"
          />
        )}
      </div>
      <div className="flex justify-center items-center py-5">
        <Pagination
          currentPage={currentPage}
          totalPages={last_page}
          handleChangePage={handlePageChange}
        />
      </div>

      {/* 5. Render the Rating Modal */}
      <StoreRatingsModal 
        isOpen={ratingModal.isOpen}
        storeId={ratingModal.storeId}
        onClose={closeRatingModal}
      />

      {deleteConfirmation.isOpen && (
        <DeleteRecord
          loadingDelete={loadingDelete}
          handelDelete={handelDelete}
          closeDeleteConfirmation={closeDeleteConfirmation}
        />
      )}
    </div>
  );
}